/**
 * Collector API payloads (e.g. GET /collector/users/:id, GET /collector/users) reuse user schema
 * on nested `dependents[]`. Soft-deleted dependents are identified by `deleted_at`, not `status`.
 *
 * - Active: `deleted_at === null` (JSON); omitted field is treated as active (same as null).
 * - Deleted: `deleted_at` is a non-null timestamp string.
 */
export function isCollectorDependentActive(dep: { deleted_at?: string | null }): boolean {
  return dep.deleted_at == null;
}

export function isCollectorDependentDeleted(dep: { deleted_at?: string | null }): boolean {
  return dep.deleted_at != null;
}
